import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import Alimentos from "./data/alimentos.json";
import Sentencias from "./data/sentencias.json";
import Violencia from "./data/violencia.json";
import Laborales from "./data/laborales.json";
import Codigos from "./data/codigos.json";
import Contractuales from "./data/contractuales.json";
import Select from "react-select";
import CardSentenciado from "./cards/CardSentenciado";
import Navigation from "./general/Navigation";
import Map from "./general/Map";
import Chart from "./general/Chart";

const NavItem = ({ currentTab, item, displayTab }) => (
  <li className="nav-item">
    <div
      className={currentTab === item.value ? "active nav-link" : "nav-link"}
      onClick={() => displayTab(item.value)}
    >
      {item.label}
    </div>
  </li>
);

function CandidatosDemandas() {
  const [currentRegion, setCurrentRegion] = useState(null);
  const [currentPartido, setCurrentPartido] = useState(null);
  const [currentCandidato, setCurrentCandidato] = useState(null);
  const [listRegiones, setListRegiones] = useState([]);
  const [listPartidos, setListPartidos] = useState([]);
  const [listCandidatos, setListCandidatos] = useState([]);
  const [listResultSentencias, setListResultSentencias] = useState([]);
  const [currentTab, setCurrentTab] = useState("regiones");
  const [initialSentencias, setInitialSentencias] = useState([]);
  const [allSentencias, setAllSentencias] = useState([]);
  const [paginationOptions, setPaginationOptions] = useState({
    currentPage: 0,
    totalPages: 0,
  });
  const [dataRegions, setDataRegions] = useState([]);
  const [dataPartidos, setDataPartidos] = useState([]);

  const tabOptions = [
    {
      value: "regiones",
      label: "Por Regiones / Cargos",
    },
    {
      value: "partidos",
      label: "Por partidos",
    },
  ];

  const initData = () => {
    let initList = Sentencias.map((item) => ({
      partido: item.partido,
      candidato: item.candidato,
      nro: item.nro,
      region: item.region,
      ano: item.ano,
      delito: item.delito,
      foto: item.foto,
      tipo: "Sentencias penales",
    }));
    initList = initList.concat(
      Alimentos.map((item) => ({
        partido: item.partido,
        candidato: item.candidato,
        nro: item.nro,
        region: item.region,
        ano: item.ano,
        delito: item.fallo,
        foto: item.foto,
        tipo: "Fallos judiciales por alimentos",
      }))
    );
    initList = initList.concat(
      Violencia.map((item) => ({
        partido: item.partido,
        candidato: item.candidato,
        nro: item.nro,
        region: item.region,
        ano: item.ano,
        delito: item.fallo,
        foto: item.foto,
        tipo: "Fallos judiciales por violencia",
      }))
    );
    initList = initList.concat(
      Laborales.map((item) => ({
        partido: item.partido,
        candidato: item.candidato,
        nro: item.nro,
        region: item.region,
        ano: "",
        delito: item.fallo,
        foto: item.foto,
        tipo: "Demandas laborales",
      }))
    );
    initList = initList.concat(
      Contractuales.map((item) => ({
        partido: item.partido,
        candidato: item.candidato,
        nro: item.nro,
        region: item.region,
        ano: "",
        delito: item.fallo,
        foto: item.foto,
        tipo: "Demandas contractuales",
      }))
    );
    return initList;
  };

  // Obtener regiones
  useEffect(() => {
    const joinData = initData();
    setInitialSentencias(joinData.sort((a, b) => a.candidato.normalize().localeCompare(b.candidato.normalize())));
    setAllSentencias(joinData);
    setListResultSentencias(joinData.slice(0, 10));
    setPaginationOptions({
      currentPage: 1,
      totalPages: Math.ceil(joinData.length / 10),
    });

    let uniqueRegion = [...new Set(joinData.map((i) => i.region))];
    uniqueRegion = [...new Set(uniqueRegion)];
    uniqueRegion.sort();
    let listRegiones = [{ value: "Todos", label: "--Todos--" }];
    setListRegiones(
      listRegiones.concat(
        uniqueRegion.map((region) => ({ value: region, label: region }))
      )
    );

    let uniquePartido = [...new Set(joinData.map((i) => i.partido))];
    uniquePartido = [...new Set(uniquePartido)];
    uniquePartido.sort();
    let listPartidos = [{ value: "Todos", label: "--Todos--" }];
    setListPartidos(
      listPartidos.concat(
        uniquePartido.map((partido) => ({ value: partido, label: partido }))
      )
    );

    let uniqueCandidato = [...new Set(joinData.map((i) => i.candidato))];
    uniqueCandidato = [...new Set(uniqueCandidato)];
    uniqueCandidato.sort();
    let listCandidatos = [{ value: "Todos", label: "--Todos--" }];
    setListCandidatos(
      listCandidatos.concat(
        uniqueCandidato.map((candidato) => ({
          value: candidato,
          label: candidato,
        }))
      )
    );

    // Grafico

    const reducer = (map, val) => {
      if (map[val] == null) {
        map[val] = 1;
      } else {
        ++map[val];
      }
      return map;
    };

    const cleanDuplicate = [...new Set(joinData.map((i) => ({candidato: i.candidato, region: i.region})))]
    const testCleanDuplicate = cleanDuplicate.filter((v,i,a)=>a.findIndex(t=>(t.candidato === v.candidato && t.region===v.region))===i)
    const groupRegionesGroup = testCleanDuplicate
      .map((char) => char.region)
      .reduce(reducer, {});

    const groupRegiones = Object.keys(groupRegionesGroup).map(
      (region, val) => ({
        id: Codigos[0][region],
        value: groupRegionesGroup[region],
        name: region,
      })
    );
    const regionsData = groupRegiones.filter((f) => f.id);
    setDataRegions(regionsData);
    //const regionsDataCargo = groupRegiones.filter((f) => !f.id);

    // Group partidos
    const groupPartidosGroup = joinData
      .map((char) => char.partido)
      .reduce(reducer, {});
    const groupPartidos = Object.keys(groupPartidosGroup).map(
      (partido, val) => ({
        href: `${process.env.REACT_APP_URL}/logos/${partido}.jpg`,
        steps: groupPartidosGroup[partido],
        name: partido,
      })
    );
    setDataPartidos(groupPartidos.sort((a, b) => a.steps - b.steps));
  }, []);

  const filterRegion = (value, all) => {
    let newSentencias = all
      ? allSentencias
      : allSentencias.filter((f) => f.region === value);
    if (currentCandidato && currentCandidato.value !== "Todos") {
      newSentencias = newSentencias.filter(
        (f) => f.candidato === currentCandidato.value
      );
    }
    if (currentPartido && currentPartido.value !== "Todos") {
      newSentencias = newSentencias.filter(
        (f) => f.partido === currentPartido.value
      );
    }
    setInitialSentencias(newSentencias.sort((a, b) => a.candidato.normalize().localeCompare(b.candidato.normalize())));
    setListResultSentencias(newSentencias.slice(0, 10));
    setPaginationOptions({
      currentPage: 1,
      totalPages: Math.ceil(newSentencias.length / 10),
    });
  };

  const filterPartido = (value, all) => {
    let newSentencias = all
      ? allSentencias
      : allSentencias.filter((f) => f.partido == value);

    if (currentCandidato && currentCandidato.value !== "Todos") {
      newSentencias = newSentencias.filter(
        (f) => f.candidato === currentCandidato.value
      );
    }
    if (currentRegion && currentRegion.value !== "Todos") {
      newSentencias = newSentencias.filter(
        (f) => f.region === currentRegion.value
      );
    }
    setInitialSentencias(newSentencias.sort((a, b) => a.candidato.normalize().localeCompare(b.candidato.normalize())));
    setListResultSentencias(newSentencias.slice(0, 10));
    setPaginationOptions({
      currentPage: 1,
      totalPages: Math.ceil(newSentencias.length / 10),
    });
  };

  const filterCandidato = (value, all) => {
    if (all) {
      const newSentencias = all
        ? allSentencias
        : allSentencias.filter((f) => f.candidato === value);

      if (currentPartido && currentPartido.value !== "Todos") {
        newSentencias = newSentencias.filter(
          (f) => f.partido === currentPartido.value
        );
      }
      if (currentRegion && currentRegion.value !== "Todos") {
        newSentencias = newSentencias.filter(
          (f) => f.region === currentRegion.value
        );
      }
      setInitialSentencias(newSentencias.sort((a, b) => a.candidato.normalize().localeCompare(b.candidato.normalize())));
      setListResultSentencias(newSentencias.slice(0, 10));
      setPaginationOptions({
        currentPage: 1,
        totalPages: Math.ceil(newSentencias.length / 10),
      });
    } else {
      const newSentencias = allSentencias.filter(
        (f) => f.candidato === value
      );
      
      setInitialSentencias(newSentencias.sort((a, b) => a.candidato.normalize().localeCompare(b.candidato.normalize())));
      setListResultSentencias(newSentencias.slice(0, 10));

      setPaginationOptions({
        currentPage: 1,
        totalPages: Math.ceil(newSentencias.length / 10),
      });
    }
  };

  const startList = () => {
    setInitialSentencias(allSentencias.sort((a, b) => a.candidato.normalize().localeCompare(b.candidato.normalize())));
    setListResultSentencias(allSentencias.slice(0, 10));
    setPaginationOptions({
      currentPage: 1,
      totalPages: Math.ceil(allSentencias.length / 10),
    });
  };

  const handleChangeRegion = (option) => {
    const all = option.value === "Todos" ? true : false;
    setCurrentRegion({ label: option.value, value: option.value });
    filterRegion(option.value, all);
  };

  const handleChangePartido = (option) => {
    const all = option.value === "Todos" ? true : false;
    setCurrentPartido({ label: option.value, value: option.value });
    filterPartido(option.value, all);
  };

  const handleChangeCandidato = (option) => {
    const all = option.value === "Todos" ? true : false;
    setCurrentCandidato({ label: option.value, value: option.value });
    filterCandidato(option.value, all);
  };

  // Pagination
  const changePage = (page) => {
    let startPage = page * 10;
    let endPage = (page + 1) * 10;
    console.log('startPage',startPage)
    console.log('endPage',endPage)
    setListResultSentencias(initialSentencias.slice(startPage, endPage));

    setPaginationOptions({ ...paginationOptions, currentPage: page + 1 });
  };

  // Click sobre tab
  const displayTab = (tab) => {
    setCurrentPartido(null);
    setCurrentCandidato(null);
    setCurrentRegion(null);
    startList();
    setCurrentTab(tab);
  };

  return (
    <div className="CandidatosDemandas">
      
      <div>
        <div className="container">

          <div className="results mt-5">
            <div className="row justify-content-center">
              <div className="col-md-5 col-sm-12 py-5">
                <ul className="nav nav-pills nav-fill">
                  {tabOptions.map((tab) => (
                    <NavItem
                      currentTab={currentTab}
                      item={tab}
                      displayTab={displayTab}
                      key={tab.value}
                    />
                  ))}
                </ul>
                {currentTab === "regiones" && dataRegions.length > 0 && (
                  <div className="py-5">
                    <Map data={dataRegions} showList={handleChangeRegion} texto="candidatos con sentencias" />
                  </div>
                )}
                {currentTab === "partidos" && (
                  <div className="py-5">
                    <Chart data={dataPartidos} showList={handleChangePartido} />
                  </div>
                )}
              </div>
              <div className="col-md-7 col-sm-12">
                <div className="row filters mt-5 no-gutters">
                  <div className="col-md-6 pr-1">
                    <Select
                      options={listCandidatos}
                      placeholder={"Candidato"}
                      onChange={handleChangeCandidato}
                    />
                  </div>
                  <div className="col-md-3 pr-1">
                    <Select
                      options={listPartidos}
                      placeholder={"Partido"}
                      onChange={handleChangePartido}
                      value={currentPartido}
                    />
                  </div>
                  <div className="col-md-3 pr-1">
                    <Select
                      options={listRegiones}
                      placeholder={"Región / Cargo"}
                      onChange={handleChangeRegion}
                      value={currentRegion}
                    />
                  </div>
                  <div className="col-12 tabs-filter"></div>
                </div>
                <div className="results mt-4 p-2">
                  {listResultSentencias.length ? (
                    <div className="table-responsive">
                      <table className="table table-hover table-sm">
                        <thead>
                          <tr>
                            <th scope="col">Candidato</th>
                            <th scope="col" className="text-left">
                              Región
                            </th>
                            <th scope="col" className="text-left">
                              Candidatura
                            </th>
                            <th scope="col" className="text-left">
                              Tipo
                            </th>
                            <th scope="col">Delito/Fallo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listResultSentencias.map((sentencia, index) => (
                            <CardSentenciado
                              sentencia={sentencia}
                              key={sentencia.candidato + sentencia.tipo}
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="container">Sin resultados.</div>
                  )}
                  <div>
                    <Navigation
                      tab="sentencias"
                      paginationOptions={paginationOptions}
                      changePage={changePage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br></br>
      <br></br>
     
    </div>
  );
}

export default CandidatosDemandas;
